<template>
    <el-container class="user-main">
        <el-header>
            <HeaderUser></HeaderUser>
        </el-header>
        <el-main v-loading.fullscreen.lock="loadingFlag"
        element-loading-background="rgba(0, 0, 0, 0.8)">
            <router-view></router-view>
        </el-main>
    </el-container>
</template>

<script>
import HeaderUser from "@/components/header/Header-user.vue";
import { mapState } from "vuex";

export default {
    components: {
        HeaderUser
    },
    data: function () {
        return {
            // loadingFlag: true
        }
    },
    mounted() {

    },
    computed: {
        ...mapState([
            'loadingFlag'
        ])
    },
    methods: {

    }
}
</script>

<style lang="scss">
.user-main {
    background-color: transparent;

    .el-main {
        background-color: transparent;
        width: 100%;
        height: 100%;
        min-width: 600px;
    }
}

.el-loading-spinner .path {
    stroke: #c5c7ca;
}
.el-loading-mask {
    height: 100%;
}
</style>
